/**
 * @see buildFieldKey in @sparknz/journeys-common for how field keys are generated
 */

export const SETUP_SECTION_ID = 'setup';
export const CONNECTION_SECTION_ID = 'connection';
export const SETUP_SERVICE_PROVIDER_ID_FIELD_KEY =
  'service_provider_id:chooseNumber=Keep my current number';
export const SETUP_SERVICE_PROVIDER_NAME_FIELD_KEY =
  'service_provider_name:chooseNumber=Keep my current number';
export const SETUP_SERVICE_PROVIDER_FIELD_NAME = 'service_provider_name';
export const SETUP_INTERNET_SERVICE_PROVIDER_ID_FIELD_KEY =
  'internetServiceProviderId:typeOfConnectionOptions=switch_from_another_provider';
export const SETUP_INTERNET_SERVICE_PROVIDER_NAME_FIELD_KEY =
  'internetServiceProvider:typeOfConnectionOptions=switch_from_another_provider';
export const SETUP_INTERNET_SERVICE_PROVIDER_FIELD_NAME =
  'internetServiceProvider';
export const SETUP_MOBILE_NUMBER_OPTION_FIELD_NAME = 'chooseNumber';
export const SETUP_PHONE_NUMBER_FIELD_KEY =
  'current_mobile_number:chooseNumber=Keep my current number';
export const SETUP_PHONE_NUMBER_FIELD_NAME = 'current_mobile_number';
export const SETUP_CONNECTION_TYPE_FIELD_NAME = 'typeOfConnectionOptions';
export const SETUP_VULNERABLE_FIELD_NAME = 'vulnerableOptions';
export const SETUP_BACKUP_DEVICE_FIELD_NAME = 'backupDeviceOptions';
export const SETUP_CALLER_DISPLAY_FIELD_NAME = 'callerDisplayOptions';

export const RESERVATION_ID_FIELD_NAME = 'reservation_id';
export const LANDLINE_RESERVATION_ID_FIELD_NAME = 'landline_reservation_id';
export const LANDLINE_PAGING_ID_FIELD_NAME = 'landline_paging_id';

export const ACCOUNT_PERSONAL_DETAILS_FIRST_NAME_NAME = 'first_name';
export const ACCOUNT_PERSONAL_DETAILS_LAST_NAME_NAME = 'last_name';
export const ACCOUNT_PERSONAL_DETAILS_EMAIL_NAME = 'email';

export const ACCOUNT_LIMITED_LIABILITY_FIRST_NAME_KEY =
  'firstName:choose_business_type=limited_liability';
export const ACCOUNT_LIMITED_LIABILITY_LAST_NAME_KEY =
  'lastName:choose_business_type=limited_liability';
export const ACCOUNT_LIMITED_LIABILITY_EMAIL_KEY =
  'email:choose_business_type=limited_liability';

export const ACCOUNT_SOLE_TRADER_FIRST_NAME_KEY =
  'firstName:choose_business_type=soleTraderAndOther';
export const ACCOUNT_SOLE_TRADER_LAST_NAME_KEY =
  'lastName:choose_business_type=soleTraderAndOther';
export const ACCOUNT_SOLE_TRADER_EMAIL_KEY =
  'email:choose_business_type=soleTraderAndOther';

export const CLICK_AND_COLLECT_FIELD_VALUE = 'Click & Collect - Free';
export const DELIVERY_SECTION_ID = 'delivery';
export const DELIVERY_STEP_PATH = 'deliveryDetails';
export const DELIVERY_METHOD_FIELD_NAME = 'choose_delivery_type';
export const DELIVERY_ADDRESS_FIELD_NAME = 'deliveryAddress';

export const PAYMENT_AMOUNT = 'paymentAmount';
export const PAYMENT_SECTION_ID = 'payment';
export const PAYMENT_STEP_PATH = 'checkout_payment';
export const PAYMENT_METHOD_FIELD_NAME = 'choosePaymentMethod';
export const PAYMENT_METHOD_ACCOUNT_OPTION_VALUE = 'Pay on your Spark account';
export const PAYMENT_METHOD_CARD_OPTION_VALUE = 'Credit/Debit Card';
export const PAYMENT_METHOD_GIFT_CARD_OPTION_VALUE = 'Gift Card';
export const PAYMENT_SAVE_CARD_FIELD_NAME = 'saveCard';
export const PAYMENT_CHOOSE_CARD_FIELD_KEY =
  'Choose_card_option:choosePaymentMethod=Credit/Debit Card';
export const PAYMENT_SAVE_CARD_FIELD_KEY = `${PAYMENT_SAVE_CARD_FIELD_NAME}:Choose_card_option=New Card`;
export const PAYMENT_TOKEN_FIELD_KEY = 'token:Choose_card_option=New Card';
export const PAYMENT_CARDHOLDER_FIELD_KEY =
  'cardholderName:Choose_card_option=New Card';
export const PAYMENT_SAVED_METHOD_ID_FIELD_KEY =
  'paymentMethodId:Choose_card_option=Existing Card';

export const AGENT_CHECKOUT_SUMMARY_ID = 'agentCheckoutSummary';
export const REVIEW_SECTION_ID = 'review';
export const REVIEW_STEP_ID = 'review';
export const REVIEW_TERMS_AND_CONDITIONS_FIELD_KEY = 'terms_and_conditions';
export const REVIEW_BLACKBOX_FIELD_KEY = 'blackboxId';
export const SPLIT_PAYMENT_SECTION_ID = 'splitPayment';
export const PAYMENT_SUMMARY_SECTION_ID = 'paymentSummary';

export const C2C_STORE_ADDRESS_ELID_FIELD_NAME =
  'click_and_collect_store_addressElid';
export const C2C_STORE_NAME_FIELD_NAME = 'clickAndCollectStoreName';
export const C2C_ADDRESS_ELID_FIELD_NAME = 'clickAndCollectAddressElid';
export const C2C_STORE_ADDRESS_FIELD_NAME = 'clickAndCollectStoreAddress';

export const CREDIT_CHECK_UPFRONT_PAYMENT = 'upfrontPayment';

export const BIOMETRICS_SECTION_ID = 'biometricCheck';
export const BIOMETRICS_STEP_ID = 'needMoreInformation';
export const BIOMETRICS_STATUS_FIELD_NAME = 'biometricStatus';
